<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » コンテンツ購入日次情報検索条件の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>コンテンツ購入日次情報検索条件の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/select-purchase-content-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png">閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png">検索条件
        </div>
        <div class="manual-explain">
          施設：<br>
          施設を選択します。<br>
          建物・カテゴリID：<br>
          建物・カテゴリIDを設定します。右のルーペアイコンをクリックすると建物・カテゴリ一覧ダイアログを表示し、建物・カテゴリを検索することができます。<br>
          利用日：開始日 - 終了日<br>
          購入日を範囲で設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png">検索ボタン
        </div>
        <div class="manual-explain">
          検索条件に設定された内容でコンテンツ購入日次情報を検索します。<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Daily Content Purchase Information Search Conditions
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Daily Content Purchase Information Search Conditions</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_select-purchase-content-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Search Conditions
        </div>
        <div class="manual-explain">
          Facility:<br>
          Select a facility.<br>
          Building/Category ID:<br>
          Set the building/category ID. Click the magnifying glass icon on the right to display the building/category list dialog and search for buildings/categories.<br>
          Usage Date: Start Date - End Date<br>
          Set the purchase date range.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Search Button
        </div>
        <div class="manual-explain">
          Search for daily content purchase information with the content set in the search conditions.<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
